var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSongbird(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 383.66 538.51",
    className: "fill-current text-pink-600 h-5 w-4",
    "fill-current": "#d53f8c",
    fill: "#d53f8c",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "124.29 316.35 0 538.51 101.68 508.22 124.29 316.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.45 315.45 135.35 299.46 119.98 431.6 300.07 320.69 259.45 315.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "195.58 206.32 233.21 158.92 40.08 0 133.09 285.06 195.58 206.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "363.82 188.11 343.46 245.8 383.66 282.19 363.82 188.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "263.6 221.16 263.6 221.16 238.46 166.78 215.95 195.14 139.88 290.97 265.69 307.18 305.76 312.35 263.6 221.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357 180.39 273.62 221.37 312.7 305.92 357 180.39"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSongbird);
export default __webpack_public_path__ + "static/media/songbird.3364e4839ea43fe0bfd1f2b00039d58f.svg";
export { ForwardRef as ReactComponent };